import {
  FETCH_SUPPORT_CASE_DETAILS,
  FETCH_SUPPORT_CASE_DETAILS_SUCCESS,
  FETCH_SUPPORT_CASE_DETAILS_FAILURE,
  DELETE_FINANCIAL_FORM_DATA,
  DELETE_FINANCIAL_FORM_DATA_SUCCESS,
  DELETE_FINANCIAL_FORM_DATA_FAILURE,
  DELETE_EXECUTIVE_SUMMARY_FINANCIAL_DATA,
  DELETE_EXECUTIVE_SUMMARY_FINANCIAL_DATA_SUCCESS,
  DELETE_EXECUTIVE_SUMMARY_FINANCIAL_DATA_FAILURE,
  TAKE_SUPPORT_AUTOMATION_BACKUP,
  TAKE_SUPPORT_AUTOMATION_BACKUP_SUCCESS,
  TAKE_SUPPORT_AUTOMATION_BACKUP_FAILURE,
  CLEAR_SUPPORT_WORK_AUTOMATION_STATE,
} from "./actionTypes";
import { initialSupportWorkState } from "./helper";

const supportWorkAutomationReducer = (
  state = initialSupportWorkState(),
  action
) => {
  switch (action.type) {
    case FETCH_SUPPORT_CASE_DETAILS:
      return {
        ...initialSupportWorkState(),
        activeTaskType: action.payload?.taskType || "",
        isFetchingCase: true,
      };
    case FETCH_SUPPORT_CASE_DETAILS_SUCCESS:
      return {
        ...state,
        isFetchingCase: false,
        caseDetails: action.data?.caseDetails || null,
        isBackupTaken: false,
        backupFileName: null,
        deleteResponse: null,
        noBackupData: Boolean(action.data?.noBackupData),
        error: action.data?.noBackupData
          ? {
              message:
                action.data?.message ||
                "No data available to take backup for this case",
              noBackupData: true,
            }
          : null,
      };
    case FETCH_SUPPORT_CASE_DETAILS_FAILURE:
      return {
        ...state,
        isFetchingCase: false,
        caseDetails: null,
        error: action.error,
      };
    case TAKE_SUPPORT_AUTOMATION_BACKUP:
      return {
        ...state,
        isTakingBackup: true,
        noBackupData: false,
        error: null,
      };
    case TAKE_SUPPORT_AUTOMATION_BACKUP_SUCCESS:
      return {
        ...state,
        isTakingBackup: false,
        isBackupTaken: true,
        noBackupData: false,
        backupFileName: action.data?.backupFileName || null,
        error: null,
      };
    case TAKE_SUPPORT_AUTOMATION_BACKUP_FAILURE:
      return {
        ...state,
        isTakingBackup: false,
        isBackupTaken: false,
        noBackupData: Boolean(action.error?.noBackupData),
        error: action.error,
      };
    case DELETE_FINANCIAL_FORM_DATA:
    case DELETE_EXECUTIVE_SUMMARY_FINANCIAL_DATA:
      return {
        ...state,
        isDeleting: true,
        error: null,
      };
    case DELETE_FINANCIAL_FORM_DATA_SUCCESS:
    case DELETE_EXECUTIVE_SUMMARY_FINANCIAL_DATA_SUCCESS:
      return {
        ...state,
        isDeleting: false,
        deleteResponse: action.data?.response || null,
        error: null,
      };
    case DELETE_FINANCIAL_FORM_DATA_FAILURE:
    case DELETE_EXECUTIVE_SUMMARY_FINANCIAL_DATA_FAILURE:
      return {
        ...state,
        isDeleting: false,
        error: action.error,
      };
    case CLEAR_SUPPORT_WORK_AUTOMATION_STATE:
      return initialSupportWorkState();
    default:
      return state;
  }
};

export default supportWorkAutomationReducer;
